import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../core';
import { AdministratorListComponent } from './administrator-list/administrator-list.component';

const routes: Routes = [
  {
    path: 'administrators',
    component: AdministratorListComponent,
    canActivate: [AuthGuard]
  }  
];

export const AdministratorsRoutes: ModuleWithProviders = RouterModule.forChild(routes);


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/administrators/administrators.routes.ts